import { connect } from "react-redux";
import { createSelector } from "reselect";
import { OptionsBlock as Component } from "./OptionsBlock";
import { Utilities } from "@learningblocks/exp-constants";

const { DESIGN_SLIDE_TYPES, SLIDE_NODE } = Utilities;

function mapStateToProps(state) {
  return getOptionsBlockPorps(state);
}

function mapDispatchToProps() {
  return {
    setAsNextStep: () => {
      // dispatch(setAsNextStep(params));
    },
  };
}

const OptionsBlock = connect(mapStateToProps, mapDispatchToProps)(Component);

export { OptionsBlock as OptionsBlockWithRedux, Component as OptionsBlock };

const getDesignSection = ({ notebook }) => notebook.designSection;

const getOptionsBlockPorps = createSelector(
  [getDesignSection],
  (designSection) => {
    const currentDesignSection = designSection.allSlides.find(
      (slide) => slide.type === designSection.currentSlide
    );

    if (currentDesignSection.type === DESIGN_SLIDE_TYPES.ONE) {
      const { incorrects, maxIncorrects, optionsTitle } = currentDesignSection;
      const optionsList = getSlideOneOptions(currentDesignSection);
      return {
        incorrects,
        maxIncorrects,
        optionsList,
        optionsTitle,
        type: currentDesignSection.type,
      };
    }

    if (currentDesignSection.type === DESIGN_SLIDE_TYPES.THREE) {
      const { incorrects, maxIncorrects, optionsTitle } = currentDesignSection;
      const optionsList = getSlideThreeOptions(currentDesignSection);
      return {
        incorrects,
        maxIncorrects,
        optionsTitle,
        optionsList,
        type: currentDesignSection.type,
      };
    }
    if (currentDesignSection.type === DESIGN_SLIDE_TYPES.TWO) {
      const { incorrects, maxIncorrects } = currentDesignSection;
      const currentNode = getCurrentNode(currentDesignSection.slideTree);
      const {
        nodeOptionsDescription: optionsDescription,
        nodeOptionsTitle: optionsTitle,
      } = currentNode;
      let optionsList = [];
      if (currentNode.nodeType != SLIDE_NODE.JOINT_PATH_SELECT) {
        optionsList = getCurrentSlideTwoOptions(currentNode);
      }
      return {
        incorrects,
        maxIncorrects,
        optionsTitle,
        optionsDescription,
        optionsList,
        type: currentDesignSection.type,
      };
    }
  }
);

function getSlideOneOptions(designSlideOne) {
  const allOptions = designSlideOne.options;
  const allDroppedOptions = designSlideOne.slideTree.map(
    (node) => node.droppedId
  );
  return allOptions.filter((option) => !allDroppedOptions.includes(option.id));
}

function getSlideThreeOptions(designSlideThree) {
  const allOptions = designSlideThree.options;
  const allDroppedOptions = designSlideThree.slideTree.reduce(
    (droppedOptions, group) => {
      for (const node of group.groupNodes) {
        if (node.droppedId !== null) {
          droppedOptions.push(node.droppedId);
        }
      }
      return droppedOptions;
    },
    []
  );
  return allOptions.filter((option) => !allDroppedOptions.includes(option.id));
}

function getCurrentNode(slideTree) {
  for (const group of slideTree) {
    for (const node of group.groupNodes) {
      if (node.current) {
        return node;
      }
    }
  }
}

function getCurrentSlideTwoOptions(currentNode) {
  const allOptions = currentNode.nodeOptions;
  const droppedOptions = getDroppedItemsInCurentNode(
    currentNode.nodeComponents
  );
  return allOptions.filter((option) => !droppedOptions.includes(option.id));
}

function getDroppedItemsInCurentNode(nodeComponents) {
  return nodeComponents.reduce((list, component) => {
    if (component.droppedId != null) {
      list.push(component.droppedId);
    }
    return list;
  }, []);
}
